<template>
  <div style="display: contents;">
      <!-- total energy amounts tr - foreach -->

      <tr v-bind:key="rate.field" v-for="rate in ratesdouble" class="trclass" :class="{'font-weight-bold': isBold(rate), 'd-none': isHiddenTr(rate)}">
        <td width="10%" :class="{'font-italic': isItalic(rate)}">{{nameColumn(rate)}} {{ handleChargeGridName(rate) }}</td>
        <td>{{basedOnColumn(rate)}}</td>
        <td style="white-space: nowrap">{{rateColumn(rate)}}</td>
        <td class="text-right">{{ $n(perMonthColumn(rate), 'currency', 'nl-NL') }}</td>
        <td class="text-right">{{ $n(perYearColumn(rate), 'currency', 'nl-NL') }}</td>
      </tr>
      <!-- end of total energy amounts tr / foreach -->

      <!-- total energy amounts tr -->
      <tr class="trclass font-weight-bold">
        <td width="10%">
          {{ translate[lang]["totalcost"] }} {{ name }}
        </td>
        <td></td>
        <td style="white-space: nowrap"></td>
        <td class="text-right">{{ $n(perMonthTotal(), 'currency', 'nl-NL') }}</td>
        <td class="text-right">{{ $n(perYearTotal(), 'currency', 'nl-NL') }}</td>
      </tr>
      <!-- end of total energy amounts tr -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "RatesTableTrElectricity",
  props: ["proposition", "name"],
  data() {
    return {
      ratesdouble: {},
      doublereturn: false,
    };
  },
  mounted() {
  },
  computed: {
    ...mapState({
      combinations: (state) => state.forms.combinations,
      solar: (state) => state.forms.solar,
      solars: (state) => state.forms.solars,
      consumption: (state) => state.forms.consumption,
      ratesloader: (state) => state.forms.ratesloader,
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
      addressResidential: (state) => state.forms.addressResidential,
      postcodeQuery: (state) => state.forms.postcodeQuery
    }),

    // overbodig? aangezien this.consumption.electric.net al de netto consumptie is?
    totalConsumption() {
      if (this.smartMeter == 1) {
        return (parseInt(this.consumption.electric.double.low) + parseInt(this.consumption.electric.double.high));
      } else {
        return parseInt(this.consumption.electric.single);
      }
    },

    totalSolar() {
      if (this.solar.kwhKnown == 1) {
        return parseInt(this.solar.single);
      } else {
        return this.calcSolarConsumption();
      }
    },
    
    netconsumption() {
      return (this.totalConsumption - this.totalSolar);
    },

    // If the low net consumption is negative while the high net consumption is positive
    // or vice versa, while the sum of both together is still positive, the extra return
    // has to be deducted from the total of the other (low or high)
    isNetted() {
      if (this.meter == 2) {
        var high = parseInt(this.consumption.electric.double.high) - parseInt(this.calcSolarConsumptionHigh());
        var low = parseInt(this.consumption.electric.double.low) - parseInt(this.calcSolarConsumptionLow());
        if (high > 0 && low < 0 || low > 0 && high < 0 && parseInt(low + high) >= 0) {
          return true;
        }
      }
      return false;
    },

    // The netting has to be deducted from 'high'
    isNettedHigh() {
      if (this.isNetted && parseInt(this.calcSolarConsumptionLow()) > parseInt(this.consumption.electric.double.low)) {
        return true;
      }
      return false;
    },

    // The netting has to be deducted from 'low'
    isNettedLow() {
      if (this.isNetted && parseInt(this.calcSolarConsumptionHigh()) > parseInt(this.consumption.electric.double.high)) {
        return true;
      }
      return false;
    },

    usageHigh() {
      var netHigh = parseInt(this.consumption.electric.double.high) - this.calcSolarConsumptionHigh();
      var netLow =  parseInt(this.consumption.electric.double.low) - this.calcSolarConsumptionLow();
      var difLow = Math.abs(netLow);

      // Als het hoge energie gebruik netto onder 0 uitkomt
      if (netHigh < 0) {
        return 0;
      }

      // Als het hoge energie gebruik netto boven 0 uitkomt
      if (netHigh >= 0 && netLow >= 0) {
        return netHigh;
      }

      // Als er alleen bij laag sprake is van teruglevering
      if (netLow < 0 && netHigh >= 0) {

        // als het verschil bij laag nog van de hoge consumptie afgetrokken kan worden 
        if (netHigh > difLow) {
          return netHigh - difLow;
        } else {
          return 0;
        }
      }
      return netHigh;
    },

    usageLow() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difHigh = Math.abs(netHigh);

      // Als er sprake is van teruglevering bij laag
      if (netLow < 0) {
        return 0;
      }

      // Als er geen sprake is van teruglevering bij zowel laag als hoog
      if (netHigh >= 0 && netLow >= 0) {
        return netLow;
      }

      // Als er alleen bij hoog sprake is van teruglevering
      if (netHigh < 0 && netLow >= 0) {

        // en het verschil bij hoog nog van de lage consumptie afgetrokken kan worden 
        if (netLow > difHigh) {
          return netLow - difHigh;
        } else {
          return 0;
        }
      }
      return netLow;
    },

    returnDeliveryLow() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difLow = Math.abs(netLow);
      //var difHigh = Math.abs(netHigh);
      
      // als laag netto onder de 0 uitkomt, en dit groter is dan het verschi
      if (netLow < 0 && difLow > netHigh) {
        return difLow;
      }

      // if both low and high energy usages are either positive or negative, there is no return delivery
      // Als er bij hoog sprake is van teruglevering, maar dit nog van de lage consumptie afgetrokken kan worden 
      if (netLow >= 0 && netHigh >= 0 || netLow < 0 && netHigh > 0 || netLow < 0 && netHigh < 0) {
        return 0;
      }

      // Als er sprake is van teruglevering
      if (netLow < 0) {
        return difLow;
      }
      return 0;
    },

    returnDeliveryHigh() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var difHigh = Math.abs(netHigh);
      //var difLow = Math.abs(netLow);

      // als hoog netto onder de 0 uitkomt, en het verschil afgetrokken is van laag
      if (netHigh < 0 && difHigh > netLow) {
        return difHigh - this.consumption.electric.double.low;
      }

      // if both low and high energy usages are either positive or negative, there is no return delivery
      // Als er bij hoog sprake is van teruglevering, maar dit nog van de lage consumptie afgetrokken kan worden 
      if (netHigh >= 0 && netLow >= 0 || netHigh < 0 && netLow > 0 || netHigh < 0 && netLow < 0) {
        return 0;
      }

      // Als er sprake is van teruglevering
      if (netHigh < 0) {
        return difHigh;
      }

      if (netLow + netHigh < 0) {
        return Math.abs(netHigh+netLow);
      }

      return 0;
    },

    returnDelivery() {
      var netHigh = this.consumption.electric.double.high - this.calcSolarConsumptionHigh();
      var netLow =  this.consumption.electric.double.low - this.calcSolarConsumptionLow();
      var net = parseInt(netHigh + netLow);
      if (net < 0) {
        return Math.abs(net);
      } else {
        return 0;
      }
    }



  },
  methods: {
    ...mapMutations({
      setTotal: "forms/SET_ENERGY_TOTAL",
    }),

    handleChargeGridName(item) {
      if (item.field == "energy_charge_grid_operation") {
        if (
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["E"] &&
            !this.postcodeQuery.error
        ) {
          return (
              " (" +
              this.postcodeQuery.network_operators["E"].filter(
                  (x) => x.connection_value == "3x25"
              )[0].name +
              ")"
          );
        }
      }
      return "";
    },

    // this.overview contains the json response with the rates
    setMyRates() {
      var rates = this.overview.find(x => x.group === 'electricity').rates;

      if (rates.find(x => x.proposition_id === this.proposition && x.field === 'return_delivery_double_low') !== undefined) {
        this.doublereturn = true;

        this.ratesdouble = {
          0: rates.find(x => x.proposition_id === this.proposition && x.field === 'rate_double_high'),
          1: rates.find(x => x.proposition_id === this.proposition && x.field === 'supply_double_high'),
          2: rates.find(x => x.proposition_id === this.proposition && x.field === 'ode_double_high'),
          3: rates.find(x => x.proposition_id === this.proposition && x.field === 'rate_double_low'),
          4: rates.find(x => x.proposition_id === this.proposition && x.field === 'supply_double_low'),
          5: rates.find(x => x.proposition_id === this.proposition && x.field === 'ode_double_low'),
          6: rates.find(x => x.proposition_id === this.proposition && x.field === 'return_delivery'),
          7: rates.find(x => x.proposition_id === this.proposition && x.field === 'energy_fixed_charge_of_supply'),
          8: rates.find(x => x.proposition_id === this.proposition && x.field === 'annual_tax_reduction'),
          9: rates.find(x => x.proposition_id === this.proposition && x.field === 'energy_charge_grid_operation'),
        }
      } else {
        this.ratesdouble = {
          
          0: rates.find(x => x.proposition_id === this.proposition && x.field === 'rate_double_high'),
          1: rates.find(x => x.proposition_id === this.proposition && x.field === 'supply_double_high'),
          2: rates.find(x => x.proposition_id === this.proposition && x.field === 'ode_double_high'),
          3: rates.find(x => x.proposition_id === this.proposition && x.field === 'rate_double_low'),
          4: rates.find(x => x.proposition_id === this.proposition && x.field === 'supply_double_low'),
          5: rates.find(x => x.proposition_id === this.proposition && x.field === 'ode_double_low'),
          6: rates.find(x => x.proposition_id === this.proposition && x.field === 'return_delivery'),
          7: rates.find(x => x.proposition_id === this.proposition && x.field === 'energy_fixed_charge_of_supply'),
          8: rates.find(x => x.proposition_id === this.proposition && x.field === 'annual_tax_reduction'),
          9: rates.find(x => x.proposition_id === this.proposition && x.field === 'energy_charge_grid_operation'),
      
        }
      }

      this.setTotal(this.perYearTotal());


    },

    // determines if the rate should display days or kWh
    rateType(rate) {
      if (rate.field == 'energy_fixed_charge_of_supply' || rate.field == 'annual_tax_reduction' || rate.field == 'energy_charge_grid_operation') {
        return this.translate[this.lang]["ratesTableDay"];
      } else {
        return 'kWh';
      }
    },

    // determine if the row has to be bold
    isBold(rate) {
      if (rate.field == 'supply_double_high' || rate.field == 'supply_double_low' || rate.field == 'ode_double_high' || rate.field == 'ode_double_low') {
        return false;
      }
      return true;
    },

    // determine if the row has to be italic
    isItalic(rate) {
      if (rate.field == 'supply_double_high' || rate.field == 'ode_double_high' || rate.field == 'supply_double_low' || rate.field == 'ode_double_low') {
        return true;
      }
      return false;
    },

    // determine if the row has to be hidden
    isHiddenTr(rate) {

      if (rate.field == 'return_delivery') {
        if (this.returnDelivery == 0) {
          return true;
        }
      }
      if (rate.field == 'return_delivery_double_high') {
        if (this.returnDelivery <= 0) {
          return true;
        }
      }
      if (rate.field == 'return_delivery_double_low') {
        return true; 
      }
      return false;
    },

    // determine if return delivery has to be showed
    hasReturn() {
      if (this.consumption.electric.net < 0) {
        return true;
      }
      return false;
    },

  // parse the value of the 'name' column
    nameColumn(rate) {
      if (this.doublereturn && rate.field == 'return_delivery_double_high' && this.returnDelivery > 0) {
        if (this.lang == 'en') {
          return 'Return Delivery';
        } else {
          return 'Terugleververgoeding over je opwek na saldering (btw-vrij tarief)';
        }
      } else {
        if (this.lang == 'en') {
          return JSON.parse(rate.name).en;
        } else {
          return JSON.parse(rate.name).nl;
        }
      }
    },

    // parse the value of the 'based on' column
    basedOnColumn(rate) {

      // based on column: Return delivery high
      if (rate.field == 'return_delivery_double_high') {
        return (this.returnDelivery) + ' kWh';
      }

      // based on column: Return delivery low
      if (rate.field == 'return_delivery_double_low') {
        return (this.returnDeliveryHigh + this.returnDeliveryLow) + ' kWh';
      }

      // based on column: Return delivery low
      if (rate.field == 'return_delivery') {
        return (this.returnDelivery) + ' kWh';
      }

      // based on column: Rate (high) with supply rate and government rates
      if (rate.field == 'rate_double_high' || rate.field == 'supply_double_high' || rate.field == 'ode_double_high') {
       return this.usageHigh + ' kWh';
      } 
      
      // based on column: Rate (low) with supply rate and government rates
      if (rate.field == 'rate_double_low' || rate.field == 'supply_double_low' || rate.field == 'ode_double_low') {
        return this.usageLow + ' kWh';
      }
      
      // other columns
      return (this.rateType(rate) == 'kWh') ? ((this.netconsumption > 0) ? this.netconsumption : 0) + ' kWh' : this.translate[this.lang]["365days"];
      
    },

    // parse the value of the rate column
    rateColumn(rate) {

      if (this.rateType(rate) === 'kWh') {
        return this.$n(rate.rate, 'currency', 'nl-DC') + ' / ' + 'kWh';
      } else {

        // show rates for "energy_charge_grid_operation"
        if(rate.field == 'energy_charge_grid_operation' &&
            this.postcodeQuery &&
            this.postcodeQuery.network_operators["E"] &&
            !this.postcodeQuery.error
        ) {
          return this.$n(this.postcodeQuery.network_operators["E"]
              .filter((x) => x.connection_value == "3x25")[0]
              .daily.replace(",", "."), 'currency', 'nl-DC') + ' / ' + this.translate[this.lang]["365days"];
        } else {
          return this.$n(rate.rate, 'currency', 'nl-DC') + ' / ' + this.translate[this.lang]["365days"];
        }

      }
    },

    // parse the value of the `per month` column
    perMonthColumn(rate) {

      // show rates for "energy_charge_grid_operation"
      if(rate.field == 'energy_charge_grid_operation' &&
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["E"] &&
          !this.postcodeQuery.error
      ) {

        return this.postcodeQuery.network_operators["E"]
            .filter((x) => x.connection_value == "3x25")[0]
            .monthly.replace(",", ".")

      } else {

        if (rate.field == 'return_delivery_double_low') {
          return parseFloat(this.returnDeliveryLow * rate.rate / 12).toFixed(2);
        }
        if (rate.field == 'return_delivery_double_high') {
          return parseFloat(this.returnDeliveryHigh * rate.rate / 12).toFixed(2);
        }
        if (rate.field == 'return_delivery') {
          return parseFloat(this.returnDelivery * rate.rate / 12).toFixed(2);
        }
        if (rate.field == 'rate_double_high') {
          return parseFloat(this.usageHigh * rate.rate / 12).toFixed(2);
        }
        if (rate.field == 'rate_double_low') {
          return parseFloat(this.usageLow * rate.rate / 12).toFixed(2);
        } else if (this.rateType(rate) === 'kWh') {
          if (parseInt(this.netconsumption) > 0) {
            return parseFloat(this.netconsumption * rate.rate / 12).toFixed(2);
          } else {
            return 0.00;
          }

        } else {
          return parseFloat((365 * rate.rate) / 12).toFixed(2);
        }

      }

    },

    // parse the value of the 'per year' column
    perYearColumn(rate) {

      if(rate.field == 'energy_charge_grid_operation' &&
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["E"] &&
          !this.postcodeQuery.error
      ) {

        return this.postcodeQuery.network_operators["E"]
            .filter((x) => x.connection_value == "3x25")[0]
            .yearly.replace(",", ".")

      } else {

        if (rate.field == 'return_delivery_double_low') {
          return parseFloat(this.returnDeliveryLow * rate.rate).toFixed(2);
        }
        if (rate.field == 'return_delivery_double_high') {
          return parseFloat(this.returnDeliveryHigh * rate.rate).toFixed(2);
        }
        if (rate.field == 'return_delivery') {
          return parseFloat(this.returnDelivery * rate.rate).toFixed(2);
        }
        if (rate.field == 'rate_double_high' || rate.field == 'supply_double_high' || rate.field == 'ode_double_high') {
          return parseFloat(this.usageHigh * rate.rate).toFixed(2);
        }
        if (rate.field == 'rate_double_low' || rate.field == 'supply_double_low' || rate.field == 'ode_double_low') {
          return parseFloat(this.usageLow * rate.rate).toFixed(2);
        }
        else if (this.rateType(rate) === 'kWh') {
          if (parseInt(this.netconsumption) > 0) {
            return parseFloat(this.netconsumption * rate.rate).toFixed(2);
          } else {
            return 0.00;
          }
        // for columns based on 365 days
        } else {
          return parseFloat(365 * rate.rate).toFixed(2);
        }

      }

    },

    // return the yearly total divided by 12
    perMonthTotal() {
      return (this.perYearTotal() / 12).toFixed(2);
    }, 

    // return the yearly total
    perYearTotal() {
      var total = 0;

      if (this.usageHigh > 0) {
        var rate_high = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'rate_double_high').rate * this.usageHigh;
        total += rate_high;
      }

      if (this.usageLow > 0) {
        var rate_low = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'rate_double_low').rate * this.usageLow;
        total += rate_low;
      }

      if (this.returnDeliveryHigh > 0 && this.doublereturn) {
         var return_delivery_high = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'return_delivery_double_low').rate * this.returnDeliveryHigh;
          total += return_delivery_high;
      }

      if (this.returnDeliveryLow > 0 && this.doublereturn) {
        var return_delivery_low = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'return_delivery_double_low').rate * this.returnDeliveryLow;
        total += return_delivery_low;
      }

      if (this.returnDelivery > 0 && !this.doublereturn) {
        var return_delivery = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'return_delivery').rate * this.returnDeliveryLow;
        total += return_delivery;
      }

      // add fixed charge of supply, tax reduction and grid charge
      var fixed_charge = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'energy_fixed_charge_of_supply').rate * 365;
      total += fixed_charge;

      if(this.addressResidential) {
        var tax_reduction = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'annual_tax_reduction').rate * 365;
        total += tax_reduction;
      }


      var grid_charge = this.overview.find(x => x.group === 'electricity').rates.find(rate => rate.proposition_id === this.proposition && rate.field === 'energy_charge_grid_operation').rate * 365;

      if(
          this.postcodeQuery &&
          this.postcodeQuery.network_operators["E"] &&
          !this.postcodeQuery.error
      ) {

        total += parseFloat(this.postcodeQuery.network_operators["E"]
            .filter((x) => x.connection_value == "3x25")[0]
            .yearly.replace(",", "."))

      } else {
        total += grid_charge;
      }
    
      return total.toFixed(2);
    }
  },
  created() {
    this.setMyRates();
    this.setTotal(this.perYearTotal());
  },
  watch: {
    consumption: {
      handler: function () {
        this.setMyRates();
      },
      deep: true,
    },
    overview: {
      handler: function () {
        this.setMyRates();
      },
      deep: true,
    },
    itemRates() {
      this.setMyRates();
    },
    form: {
      handler: function () {
        this.setMyRates();
      },
      deep: true,
    },
    solar: {
      handler: function () {
        this.setMyRates();
      },
      deep: true,
    },
    ratesloader: {
      handler: function () {
        this.setMyRates();
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
